import { useDispatch } from "react-redux";


import FoodOverviewGrid from "../FoodOverviewGrid";
import MealOverviewGrid from "../MealOverviewGrid";

import {
  addMealEntry,
  addFoodEntry,
  addFoodToMealEntry,
} from "../../store/todaySlice";

import { colors, space, radius, borders, fontWeight, fontSize } from "../../design/tokens";

import {
  Card,
  TextInput,
  Button,
  Text,
  Row,
  Dialog

} from "../layout";

export default function TodayDialogs({
  openFoods,
  openMeals,
  openSingleFoods,
  activeEntryId,
  onCloseFoods,
  onCloseMeals,
  onCloseSingleFoods,
}) {
  const dispatch = useDispatch();

  return (
    <>
      {/* ADD FOOD TO MEAL */}
      <Dialog open={openFoods} onClose={onCloseFoods} label="Select Single food" fullWidth>
  
          <FoodOverviewGrid
            onSelectFood={(food) => {
              dispatch(
                addFoodToMealEntry({
                  entryId: activeEntryId,
                  foodId: food.id,
                  grams: 100,
                })
              );
              onCloseFoods();
            }}
          />

      </Dialog>

      {/* ADD MEAL */}
      <Dialog open={openMeals} onClose={onCloseMeals} label="Select meal" fullWidth>


          <MealOverviewGrid
            onSelectMeal={(meal) => {
              dispatch(addMealEntry(meal));
              onCloseMeals();
            }}
          />

      </Dialog>

      {/* ADD SINGLE FOOD */}
      <Dialog open={openSingleFoods} onClose={onCloseSingleFoods} label="Select food" fullWidth>

          <FoodOverviewGrid
            onSelectFood={(food) => {
              dispatch(addFoodEntry(food));
              onCloseSingleFoods();
            }}
          />

      </Dialog>
    </>
  );
}